import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { DialogModalDS, ButtonDS, TextCapitalized } from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import styled from "styled-components";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { useCallback } from "react";
import { deleteDepartmentOfCompanyAsync } from "../departmentsSlice";
import { DeleteDepartmentOfCompanyPayload } from "../departmentsApi";
import { selectCompany, selectManager } from "../../homeSlice";
import { useNavigate } from "react-router-dom";

export interface DepartmentDeleteModalProps {
  isVisible: boolean;
  onCloseModal: () => void;
  departmentUuid: string;
}

export const DepartmentDeleteModal = (props: DepartmentDeleteModalProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const firstPath = location.pathname.split("/")[1]; 
  const company = useAppSelector(selectCompany);
  const manager = useAppSelector(selectManager);

  const onDeleteDepartment = useCallback(() => {
    if (!company || !manager) return;
    
    const departmentPayload: DeleteDepartmentOfCompanyPayload = {
      companyUuid: company.uuid,
      departmentUuid: props.departmentUuid,
      updatedBy: manager.uuid
    };

    void dispatch(deleteDepartmentOfCompanyAsync(departmentPayload));
    props.onCloseModal();
    navigate(`/${firstPath}/departments`);
  }, [company, dispatch, manager, props, navigate, firstPath])

  return (
    <DialogModalDS
      visible={props.isVisible}
      width={40}
      onClose={() => {
        props.onCloseModal();
      }}
      title={t("departments.delete.modal.title")}
      bottomButtons={{
        leftButton: (
          <ButtonDS
            text={t("departments.delete.modal.button.cancel")}
            onClick={() => {
              props.onCloseModal();
            }}
            buttonType={"secondary"}
            format={"fill"}
          />
        ),
        rightButton: (
          <ButtonDS
            text={t("departments.delete.modal.button.confirm")}
            onClick={() => onDeleteDepartment()}
            buttonType={"primary"}
            format={"fill"}
          />
        ),
      }}
    >
      <StyledContent>
        <TextCapitalized>{t("departments.delete.modal.content")}</TextCapitalized>
      </StyledContent>
    </DialogModalDS>
  );
};

const StyledContent = styled.div`
  ${typographies["Body/S"]};
  color: ${colors["colors/text/lightGrey"]};
`;